import {API_URL} from '../../../../resources/api';

export const ticketsURL : string = `${API_URL}dashboard/summary/tickets`;
export const dailyURL : string = `${API_URL}dashboard/summary/daily`;
export const weeklyURL : string = `${API_URL}dashboard/summary/weekly`;
export const monthlyURL : string = `${API_URL}dashboard/summary/monthly`;
export const yearlyURL : string = `${API_URL}dashboard/summary/yearly`;
export const serversURL : string = `${API_URL}dashboard/summary/servers`;